import { render, staticRenderFns } from "./NovaPoshtaSender.vue?vue&type=template&id=c85fc622&scoped=true"
import script from "./NovaPoshtaSender.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85fc622",
  null
  
)

export default component.exports